import { render, staticRenderFns } from "./musicBox.vue?vue&type=template&id=7af3cad0&scoped=true&"
import script from "./musicBox.vue?vue&type=script&lang=js&"
export * from "./musicBox.vue?vue&type=script&lang=js&"
import style0 from "./musicBox.vue?vue&type=style&index=0&id=7af3cad0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af3cad0",
  null
  
)

export default component.exports